(function () {
  document.querySelectorAll('.pt-section').forEach(function (section) {
    // Gallery
    // Wishlist heart
    var wishlistBtn = section.querySelector('[data-pt-wishlist-toggle]');
    if (wishlistBtn) {
      var wishlistItem = {
        handle: wishlistBtn.getAttribute('data-pt-wishlist-handle'),
        title: wishlistBtn.getAttribute('data-pt-wishlist-title'),
        url: wishlistBtn.getAttribute('data-pt-wishlist-url'),
        image: wishlistBtn.getAttribute('data-pt-wishlist-image'),
        price: wishlistBtn.getAttribute('data-pt-wishlist-price')
      };

      function syncWishlistState() {
        if (!window.misuiWishlist) return;
        var active = window.misuiWishlist.has(wishlistItem.handle);
        wishlistBtn.classList.toggle('is-active', active);
        wishlistBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }

      wishlistBtn.addEventListener('click', function () {
        if (!window.misuiWishlist) {
          console.error('misuiWishlist no está disponible — revisa que header-misui.js se cargue en esta página.');
          return;
        }
        var wasActive = window.misuiWishlist.has(wishlistItem.handle);
        window.misuiWishlist.toggle(wishlistItem);
        syncWishlistState();

        if (window.misuiToast) {
          window.misuiToast.show(wasActive ? 'Removed from wishlist' : 'Added to wishlist');
        }

        // Solo abrimos el drawer cuando se AÑADE, no cuando se quita
        if (!wasActive) {
          var wishlistOpenBtn = document.querySelector('[data-misui-wishlist-open]');
          if (wishlistOpenBtn) {
            wishlistOpenBtn.click();
          }
        }
      });

      document.addEventListener('wishlist:updated', syncWishlistState);

      // Espera a que misuiWishlist esté listo (por si header-misui.js
      // todavía no ha corrido cuando este script se ejecuta)
      if (window.misuiWishlist) {
        syncWishlistState();
      } else {
        var wishlistReadyCheck = setInterval(function () {
          if (window.misuiWishlist) {
            clearInterval(wishlistReadyCheck);
            syncWishlistState();
          }
        }, 50);
        setTimeout(function () { clearInterval(wishlistReadyCheck); }, 5000);
      }
    }
    var thumbs = section.querySelectorAll('[data-pt-thumb]');
    var mains = section.querySelectorAll('[data-pt-main]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-pt-thumb');
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-pt-thumb') === idx);
          t.setAttribute('aria-selected', t.getAttribute('data-pt-thumb') === idx ? 'true' : 'false');
        });
        mains.forEach(function (m) {
          m.classList.toggle('is-active', m.getAttribute('data-pt-main') === idx);
        });
      });
    });

    // Details toggle
    var detailsBtn = section.querySelector('[data-pt-details]');
    var detailsPanel = section.querySelector('[data-pt-details-panel]');
    if (detailsBtn && detailsPanel) {
      detailsBtn.addEventListener('click', function () {
        var open = detailsPanel.classList.toggle('is-open');
        detailsBtn.classList.toggle('is-open', open);
      });
    }

    // Variant selection
    var form = section.querySelector('form[action*="/cart/add"]');
    var variantsScript = section.querySelector('[data-pt-variants]');
    var addBtn = section.querySelector('[data-pt-add-btn]');
    var advisorBtn = section.querySelector('[data-pt-advisor-btn]');

    // Muestra el botón "Add to basket" o "Contact an advisor" según stock
    function setAvailabilityUI(available) {
      if (!addBtn) return;

      if (!available && advisorBtn) {
        // Hay botón de advisor configurado: lo mostramos y ocultamos add-to-basket
        addBtn.style.display = 'none';
        advisorBtn.style.display = '';
      } else {
        // Disponible, o no hay advisor configurado: comportamiento normal
        addBtn.style.display = '';
        if (advisorBtn) advisorBtn.style.display = 'none';
        addBtn.disabled = !available;
        addBtn.textContent = available
          ? (addBtn.dataset.addLabel || 'Add to basket')
          : 'Sold out';
      }
    }

    // AJAX add-to-cart — abre el drawer en vez de recargar la página
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[data-pt-add-btn]');
        if (!submitBtn || submitBtn.disabled) return;

        var originalText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(Object.fromEntries(new FormData(form)))
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              // Error de Shopify (ej. sin stock) — data.description trae el mensaje
              submitBtn.textContent = data.description || 'Error';
              return;
            }
            return fetch('/cart.js');
          })
          .then(function (res) { return res && res.json(); })
          .then(function (cart) {
            if (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
            }
          })
          .catch(function (err) { console.error('Add to cart error:', err); })
          .finally(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          });
      });
    }

    if (form && variantsScript) {
      var variants;
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = null; }
      if (variants) {
        var idInput = form.querySelector('input[name="id"]');
        var selects = section.querySelectorAll('[data-pt-option]');

        var updateVariant = function () {
          var selected = Array.from(selects).map(function (s) { return s.value; });
          var match = variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === selected[i]; });
          });
          if (!match) return;
          idInput.value = match.id;
          setAvailabilityUI(match.available);
        };
        selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
      }
    }

    // ------------------------------------------------------------------
    // Lupa de zoom — lightbox con zoom (rueda / pinch) y pan (arrastrar)
    // ------------------------------------------------------------------
    var zoomOverlay = section.querySelector('[data-pt-zoom-overlay]');
    var zoomTriggers = section.querySelectorAll('[data-pt-zoom-open]');

    if (zoomOverlay && zoomTriggers.length) {
      var zoomStage = zoomOverlay.querySelector('[data-pt-zoom-stage]');
      var zoomImgs = Array.prototype.slice.call(zoomOverlay.querySelectorAll('[data-pt-zoom-img]'));
      var zoomCounter = zoomOverlay.querySelector('[data-pt-zoom-counter]');
      var zoomCloseBtn = zoomOverlay.querySelector('[data-pt-zoom-close]');
      var zoomInBtn = zoomOverlay.querySelector('[data-pt-zoom-in]');
      var zoomOutBtn = zoomOverlay.querySelector('[data-pt-zoom-out]');
      var zoomResetBtn = zoomOverlay.querySelector('[data-pt-zoom-reset]');
      var zoomPrevBtn = zoomOverlay.querySelector('[data-pt-zoom-prev]');
      var zoomNextBtn = zoomOverlay.querySelector('[data-pt-zoom-next]');

      var currentIndex = 0;
      var scale = 1;
      var minScale = 1;
      var maxScale = 5;
      var posX = 0;
      var posY = 0;
      var isPanning = false;
      var startX = 0;
      var startY = 0;
      var lastDistance = null;
      var lastFocusedEl = null;

      function activeZoomImg() {
        return zoomImgs[currentIndex];
      }

      function applyTransform() {
        var img = activeZoomImg();
        if (!img) return;
        img.style.transform = 'translate(-50%, -50%) translate(' + posX + 'px, ' + posY + 'px) scale(' + scale + ')';
        if (zoomStage) zoomStage.classList.toggle('is-panning', isPanning);
      }

      function clampPan() {
        var maxPan = (scale - 1) * 400;
        if (maxPan < 0) maxPan = 0;
        posX = Math.max(-maxPan, Math.min(maxPan, posX));
        posY = Math.max(-maxPan, Math.min(maxPan, posY));
      }

      function setScale(newScale) {
        scale = Math.max(minScale, Math.min(maxScale, newScale));
        if (scale === minScale) { posX = 0; posY = 0; }
        clampPan();
        applyTransform();
      }

      function resetZoom() {
        scale = 1;
        posX = 0;
        posY = 0;
        applyTransform();
      }

      function updateCounter() {
        if (zoomCounter) {
          zoomCounter.textContent = (currentIndex + 1) + ' / ' + zoomImgs.length;
        }
      }

      function goToZoomIndex(index) {
        if (!zoomImgs.length) return;
        resetZoom();
        currentIndex = (index + zoomImgs.length) % zoomImgs.length;
        zoomImgs.forEach(function (img, i) {
          img.classList.toggle('is-active', i === currentIndex);
        });
        // Sincroniza galería principal + miniaturas
        thumbs.forEach(function (t) {
          var idx = parseInt(t.getAttribute('data-pt-thumb'), 10);
          t.classList.toggle('is-active', idx === currentIndex);
          t.setAttribute('aria-selected', idx === currentIndex ? 'true' : 'false');
        });
        mains.forEach(function (m) {
          var idx = parseInt(m.getAttribute('data-pt-main'), 10);
          m.classList.toggle('is-active', idx === currentIndex);
        });
        updateCounter();
      }

      function openZoom(index) {
        lastFocusedEl = document.activeElement;
        goToZoomIndex(index);
        zoomOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (zoomCloseBtn) zoomCloseBtn.focus();
        document.addEventListener('keydown', onZoomKeydown);
      }

      function closeZoom() {
        zoomOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
        resetZoom();
        document.removeEventListener('keydown', onZoomKeydown);
        if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
          lastFocusedEl.focus();
        }
      }

      function onZoomKeydown(e) {
        if (e.key === 'Escape') closeZoom();
        else if (e.key === 'ArrowRight') goToZoomIndex(currentIndex + 1);
        else if (e.key === 'ArrowLeft') goToZoomIndex(currentIndex - 1);
        else if (e.key === '+' || e.key === '=') setScale(scale + 0.4);
        else if (e.key === '-') setScale(scale - 0.4);
      }

      zoomTriggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-pt-zoom-open'), 10) || 0;
          openZoom(idx);
        });
      });

      if (zoomCloseBtn) zoomCloseBtn.addEventListener('click', closeZoom);
      zoomOverlay.addEventListener('click', function (e) {
        if (e.target === zoomOverlay) closeZoom();
      });
      if (zoomPrevBtn) zoomPrevBtn.addEventListener('click', function () { goToZoomIndex(currentIndex - 1); });
      if (zoomNextBtn) zoomNextBtn.addEventListener('click', function () { goToZoomIndex(currentIndex + 1); });
      if (zoomInBtn) zoomInBtn.addEventListener('click', function () { setScale(scale + 0.5); });
      if (zoomOutBtn) zoomOutBtn.addEventListener('click', function () { setScale(scale - 0.5); });
      if (zoomResetBtn) zoomResetBtn.addEventListener('click', resetZoom);

      if (zoomStage) {
        // Zoom con rueda del ratón
        zoomStage.addEventListener('wheel', function (e) {
          e.preventDefault();
          var delta = e.deltaY > 0 ? -0.2 : 0.2;
          setScale(scale + delta);
        }, { passive: false });

        // Doble clic para alternar zoom rápido
        zoomStage.addEventListener('dblclick', function () {
          if (scale > minScale) {
            resetZoom();
          } else {
            setScale(2.5);
          }
        });

        // Pan con ratón (solo si hay zoom aplicado)
        zoomStage.addEventListener('mousedown', function (e) {
          if (scale <= minScale) return;
          isPanning = true;
          startX = e.clientX - posX;
          startY = e.clientY - posY;
          applyTransform();
        });
        window.addEventListener('mousemove', function (e) {
          if (!isPanning) return;
          posX = e.clientX - startX;
          posY = e.clientY - startY;
          clampPan();
          applyTransform();
        });
        window.addEventListener('mouseup', function () {
          if (isPanning) {
            isPanning = false;
            applyTransform();
          }
        });

        // Touch: pinch-to-zoom y arrastre con un dedo
        zoomStage.addEventListener('touchstart', function (e) {
          if (e.touches.length === 2) {
            lastDistance = getTouchDistance(e.touches);
          } else if (e.touches.length === 1 && scale > minScale) {
            isPanning = true;
            startX = e.touches[0].clientX - posX;
            startY = e.touches[0].clientY - posY;
          }
        }, { passive: true });

        zoomStage.addEventListener('touchmove', function (e) {
          if (e.touches.length === 2) {
            e.preventDefault();
            var newDistance = getTouchDistance(e.touches);
            if (lastDistance != null) {
              var factor = newDistance / lastDistance;
              setScale(scale * factor);
            }
            lastDistance = newDistance;
          } else if (e.touches.length === 1 && isPanning) {
            posX = e.touches[0].clientX - startX;
            posY = e.touches[0].clientY - startY;
            clampPan();
            applyTransform();
          }
        }, { passive: false });

        zoomStage.addEventListener('touchend', function (e) {
          if (e.touches.length < 2) lastDistance = null;
          if (e.touches.length === 0) isPanning = false;
        });
      }

      function getTouchDistance(touches) {
        var dx = touches[0].clientX - touches[1].clientX;
        var dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
    }
  });
})();